












































import { Vue, Component } from "vue-property-decorator";
import { validateForm, validateRequired, validateTel, validateEmail,validateWorkTel } from "./validate.js";
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";

@Component({
  components: {
    ReadTo
  }
})
export default class RegisterStepOne extends Vue {
  //status 1 已完成 2 进行中 3未完成
  stepList = [
    {
      step: 1,
      text: "选择业务范围",
      status: 1
    },
    {
      step: 2,
      text: "填写公司基本信息",
      status: 1
    },
    {
      step: 3,
      text: "填写公司经营信息",
      status: 1
    },
    {
      step: 4,
      text: "填写业务联系人信息",
      status: 2
    },
    {
      step: 5,
      text: "完成登记",
      status: 3
    }
  ];
  dataList = [
    {
      data: "",
      label: "联系人姓名",
      placeholder: "请输入联系人姓名",
      warn: "请输入业务联系人",
      require: true,
      name: 'contactName',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "办公电话",
      placeholder: "请输入办公电话，便于联系",
      warn: "请输入办公电话",
      require: true,
      name: 'officePhone',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateWorkTel
    },
    {
      data: "",
      label: "手机号",
      placeholder: "请输入手机号",
      warn: "请输入手机号",
      require: true,
      name: 'phoneNumber',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateTel
    },
    {
      data: "",
      label: "电子邮箱",
      placeholder: "请输入电子邮箱地址",
      warn: "请输入电子邮箱",
      require: true,
      name: 'email',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateEmail
    }
  ];
  isCheck = false;
  mounted() {
    // 添加用于判断是 c端 还是 b端的 local storage
  }
  onStep(step: number) {
    if (step == -1) {
      return this.$emit("onStep", step);
    }

    if (!this.isCheck) {
      this.$message.error("请仔细阅读并同意隐私协议");
      return;
    }

    const result = validateForm(this.dataList);
    !result && this.$emit("onStep", step, this.dataList);
  }
  toAgreement() {
    this.$router.push({
      path: "/privacy/agreement"
    });
  }
  onScan() {
    if (!this.isCheck) {
      this.$message.error("请阅读并同意隐私协议");
      return;
    }

    const result = validateForm(this.dataList);
    !result && this.$emit("onScan", this.dataList);
  }
}
